import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';
import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { Encoding, EncodingResult } from '@mode-vegas/vegas';
import { TotalHelpers } from '@mode/charts/util-vegas';
import { FeatureFlag, FeatureFlagsFacade, FlamingoTypes } from '@mode/shared/contract-common';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'mode-totals-button',
  templateUrl: './totals-button.component.html',
  styleUrls: ['./totals-button.component.scss'],
})
export class TotalsButtonComponent implements OnChanges {
  @Input() disabled = false;
  @Input() encoding!: Encoding;
  @Input() model!: FlamingoTypes.ModeModel;
  @Input() view = '';

  @Output()
  encodingChange = new EventEmitter<EncodingResult>();

  isSubtotalsFFEnabled$: Observable<boolean>;
  readonly isAnalystStudio = this.thoughtspotIntegrationService.currOrgIntegrated();

  // Grand totals
  private isColGTEnabled = false;
  private isRowGTEnabled = false;

  private isColGTAllowed = false;
  private isRowGTAllowed = false;

  // Subtotals
  private isColSubTEnabled = false;
  private isRowSubTEnabled = false;

  private isColSubTAllowed = false;
  private isRowSubTAllowed = false;

  constructor(
    private featureFlagsFacade: FeatureFlagsFacade,
    private thoughtspotIntegrationService: ThoughtspotIntegrationService
  ) {
    this.isSubtotalsFFEnabled$ = this.featureFlagsFacade.asObservable(FeatureFlag.VizExplorerSubtotals);
  }

  ngOnChanges() {
    this.handleEncodingUpdate();
  }

  handleEncodingUpdate() {
    // Totals
    this.isColGTEnabled = this.encoding.totals?.grand.column === true;
    this.isRowGTEnabled = this.encoding.totals?.grand.row === true;
    const totalsCandidacy = TotalHelpers.getGrandTotalCandidacy(this.encoding, this.model, this.view);
    this.isRowGTAllowed = totalsCandidacy.row;
    this.isColGTAllowed = totalsCandidacy.col;

    // Subtotals
    const subtotalsCandidacy = TotalHelpers.getSubtotalsCandidacy(this.encoding, this.model, this.view);
    this.isColSubTEnabled = this.encoding.totals?.subtotal?.column === true;
    this.isRowSubTEnabled = this.encoding.totals?.subtotal?.row === true;
    this.isColSubTAllowed = subtotalsCandidacy.col;
    this.isRowSubTAllowed = subtotalsCandidacy.row;
  }

  toggleRowGrandTotal() {
    this.encodingChange.emit(
      this.isRowGTEnabled
        ? TotalHelpers.disableRowGrandTotal(this.encoding)
        : TotalHelpers.enableRowGrandTotal(this.encoding)
    );
  }

  toggleColumnGrandTotal() {
    this.encodingChange.emit(
      this.isColGTEnabled
        ? TotalHelpers.disableColGrandTotal(this.encoding)
        : TotalHelpers.enableColGrandTotal(this.encoding)
    );
  }

  get isColGrandTotalEnabled() {
    return this.isColGTEnabled && this.isColGTAllowed;
  }

  get isRowGrandTotalEnabled() {
    return this.isRowGTEnabled && this.isRowGTAllowed;
  }

  get isColGrandTotalAllowed() {
    return this.isColGTAllowed;
  }

  get isRowGrandTotalAllowed() {
    return this.isRowGTAllowed;
  }

  toggleRowSubtotals() {
    this.encodingChange.emit(
      this.isRowSubTEnabled
        ? TotalHelpers.disableRowSubtotals(this.encoding)
        : TotalHelpers.enableRowSubtotals(this.encoding)
    );
  }

  toggleColumnSubtotals() {
    this.encodingChange.emit(
      this.isColSubTEnabled
        ? TotalHelpers.disableColSubtotals(this.encoding)
        : TotalHelpers.enableColSubtotals(this.encoding)
    );
  }

  get isColSubtotalsEnabled() {
    return this.isColSubTEnabled && this.isColSubTAllowed;
  }

  get isRowSubtotalsEnabled() {
    return this.isRowSubTEnabled && this.isRowSubTAllowed;
  }

  get isColSubtotalsAllowed() {
    return this.isColSubTAllowed;
  }

  get isRowSubtotalsAllowed() {
    return this.isRowSubTAllowed;
  }
}
